import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

export const useScrollPosition = (wait = 50) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = debounce(
      () => {
        setScrollPosition(window.scrollY);
      },
      wait,
      { trailing: true, leading: true },
    );

    window.addEventListener('scroll', updatePosition);
    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return scrollPosition;
};
